import { Box, Chip } from "@mui/material";
import { RequirementTypes } from "../../../../views/user/EmployeeServices/Requirement/AddOrUpdateRequirementRequest";
import ToolTip from "../../../ToolTip/ToolTip";
import { Icon } from "@iconify/react/dist/iconify.js";
import { CreatedAt } from "../../../../utils/constants/CreatedAt";
const handleToolTip = (value) => {
  return <ToolTip content={value} expand={value} />;
};
export const RequirementTableHeader = ({ procurement }) => [
  { field: "sl_no", headerName: "Serial No", width: 80 },
  { field: "subCategoryName", headerName: "Requested Item", width: 220 },
  {
    field: "productName",
    headerName: "Product Name",
    width: 220,
    valueGetter: (params) =>
      params.row.productName ? params.row.productName : "N/A",
  },
  {
    field: "productSerialCode",
    headerName: "Interval Serial Code",
    width: 220,
    valueGetter: (params) =>
      params.row.productSerialCode ? params.row.productSerialCode : "N/A",
  },
  { field: "count", headerName: "Quantity", width: 80 },
  { field: "buyerName", headerName: "Requested By", width: 220 },
  { field: "departmentName", headerName: "Department", width: 220 },
  { field: "designationName", headerName: "Designation", width: 250 },
  {
    field: "createdAt",
    headerName: "Requested Date",
    width: 200,
    renderCell: (params) => {
      return CreatedAt(params.row.createdAt);
    },
  },
  {
    field: "remarks",
    headerName: "Remarks",
    width: 220,
    renderCell: (params) => {
      return (
        <ToolTip
          expand={params.row.remarks ? params.row.remarks : "N/A"}
          content={params.row.remarks ? params.row.remarks : "N/A"}
        />
      );
    },
  },
  {
    field: "isHeadApproved",
    headerName: "Head Approval Status",
    width: 200,
    renderCell: (params) => {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {params.row.isHeadApproved === 2 ? (
            <>
              <Icon
                icon="fluent:text-change-reject-20-filled"
                width="20"
                height="20"
                style={{ color: "#eb0000", marginRight: "4px" }}
              />
              Rejected
            </>
          ) : params.row.isHeadApproved === 1 ? (
            <>
              <Icon
                icon="icon-park-twotone:success"
                width="20"
                height="20"
                style={{ color: "#2acc1e", marginRight: "4px" }}
              />
              Approved
            </>
          ) : (
            <>
              <Icon
                icon="material-symbols:pending"
                width="20"
                height="20"
                style={{ color: "#f1f139", marginRight: "4px" }}
              />
              Pending
            </>
          )}
        </Box>
      );
    },
  },

  {
    field: "isProcurementHeadApproved",
    headerName: "ProcurementHead Approval Status",
    width: 220,
    renderCell: (params) => {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {params.row.isProcurementHeadApproved === 2 ? (
            <>
              <Icon
                icon="fluent:text-change-reject-20-filled"
                width="20"
                height="20"
                style={{ color: "#eb0000", marginRight: "4px" }}
              />
              Rejected
            </>
          ) : params.row.isProcurementHeadApproved === 1 ? (
            <>
              <Icon
                icon="icon-park-twotone:success"
                width="20"
                height="20"
                style={{ color: "#2acc1e", marginRight: "4px" }}
              />
              Approved
            </>
          ) : (
            <>
              <Icon
                icon="material-symbols:pending"
                width="20"
                height="20"
                style={{ color: "#f1f139", marginRight: "4px" }}
              />
              Pending
            </>
          )}
        </Box>
      );
    },
  },

  {
    field: "ProcurementHeadApprovedDate",
    headerName: "ProcurementHead Approved Date",
    width: 220,
    renderCell: (params) => {
      return CreatedAt(params.row.ProcurementHeadApprovedDate);
    },
  },

  {
    field: "expectedDeliveryDate",
    headerName: "Expected Delivery Date",
    width: 220,
    renderCell: (params) => {
      return CreatedAt(params.row.expectedDeliveryDate);
    },
  },
  {
    field: "expectedDeliveryFromTime",
    headerName: "Expected Delivery Time",
    width: 220,
    renderCell: (params) => {
      const formatTo12Hour = (timeStr) => {
        if (!timeStr) return "";
        const [hour, minute] = timeStr.split(":").map(Number);
        const suffix = hour >= 12 ? "PM" : "AM";
        const hour12 = hour % 12 === 0 ? 12 : hour % 12;
        return `${hour12}:${minute.toString().padStart(2, "0")} ${suffix}`;
      };

      const from = formatTo12Hour(params.row.expectedDeliveryFromTime);
      const to = formatTo12Hour(params.row.expectedDeliveryToTime);
      return !from && !to ? "N/A" : `${from} - ${to}`;
    },
  },
  // {
  //   field: "expectedDeliveryToTime",
  //   headerName: "Expected Delivery Time",
  //   width: 220,
  // },

  {
    field: "deliveryStatus",
    headerName: "Procurement Delivery Status",
    width: 200,
    renderCell: (params) => {
      return params.row.deliveryStatus == 0 ? (
        <>
          <Icon
            icon="material-symbols:pending"
            width="20"
            height="20"
            style={{ color: "#f1f139", marginRight: "4px" }}
          />
          Pending
        </>
      ) : params.row.deliveryStatus == 1 ? (
        <>
          <Icon
            icon="mdi:package-delivered"
            width="20"
            height="20"
            style={{ color: "#2acc1e", marginRight: "4px" }}
          />
          Delivered
        </>
      ) : (
        <>
          <Icon
            icon="material-symbols:assignment-returned"
            width="20"
            height="20"
            style={{ color: "#eb0000", marginRight: "4px" }}
          />
          Returned
        </>
      );
    },
  },
  {
    field: "color",
    headerName: "Color",
    width: 150,
    valueGetter: (params) => (params.row.color ? params.row.color : "N/A"),
  },
  {
    field: "IdNumber",
    headerName: "Product Id Number",
    width: 350,
    renderCell: (params) => handleToolTip(params.row.IdNumber || "N/A"),
  },
  {
    field: "soldAt",
    headerName: "Sold Date",
    width: 200,
    renderCell: (params) => {
      return params.row.soldAt ? CreatedAt(params.row.soldAt) : "N/A";
    },
  },

  {
    field: "soldBy",
    headerName: "Sold By",
    width: 220,
    renderCell: (params) => {
      return params.row.soldBy ? params.row.soldBy : "N/A";
    },
  },
  {
    field: "returnedAt",
    headerName: "Returned Date",
    width: 200,
    valueGetter: (params) =>
      params.row.returnedAt ? CreatedAt(params.row.returnedAt) : "N/A",
  },
  {
    field: "isDamaged",
    headerName: "Product Status",
    width: 200,
    renderCell: (params) => {
      return params.row.isDamaged && params.row.damagedAmount ? (
        <Chip label="Damaged (Physical)" variant="outlined" color="error" />
      ) : params.row.isDamaged ? (
        <Chip label="Damaged" variant="outlined" color="error" />
      ) : (
        <Chip label="Not Damaged" variant="outlined" color="success" />
      );
    },
  },
  {
    field: "damagedReason",
    headerName: "Damaged Reason",
    width: 200,
    renderCell: (params) => handleToolTip(params.row.damagedReason || "N/A"),
  },
  {
    field: "damagedAmount",
    headerName: "Damaged Amount",
    width: 150,
    valueGetter: (params) =>
      params.row.damagedAmount ? params.row.damagedAmount : "N/A",
  },
  ...(procurement
    ? [
        {
          field: "category_type_name",
          headerName: "Type Name",
          width: 150,
          valueGetter: (params) =>
            params.row.category_type_name
              ? params.row.category_type_name
              : "N/A",
        },
        {
          field: "categoryName",
          headerName: "Category Name",
          width: 200,
          valueGetter: (params) =>
            params.row.categoryName ? params.row.categoryName : "N/A",
        },
        {
          field: "brandName",
          headerName: "Brand Name",
          width: 200,
          valueGetter: (params) =>
            params.row.brandName ? params.row.brandName : "N/A",
        },
        {
          field: "vendorName",
          headerName: "Vendor Name",
          width: 200,
          valueGetter: (params) =>
            params.row.vendorName ? params.row.vendorName : "N/A",
        },
      ]
    : []),
];
